const prerender = () => {
  if (window) {
    window.prerenderReady = true;
    const metaTag = document.querySelector("meta[name=prerender-status-code]");
    if (metaTag) metaTag.setAttribute("content", "200");
  }
};
export {
  prerender as default
};
//# sourceMappingURL=prerender.mjs.map
